export enum WrapPanelVisibility {
  Visible = 'visible',
  None = 'none',
  Hide = 'hide',
  OpacityZero = 'opacity-zero',
}
